import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { IAllRequirements } from "../../models/AllRequirements";
import { Tag } from "primereact/tag";
import { format } from "date-fns";
import { Fetch } from "../../shared/Fetch";

interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
    toast: any,
    FromDate?: Date | null,
    ToDate?: Date | null,
    isReleasedTrue?: boolean,
    isHold?: boolean
}

interface IIncentiveReqList {
    project_Start_Date1?: string,
    project_End_Date1?: string,
    pO_Status?: string,
    vendor_Company_Name?: string,
    req_ID?: string,
    consultant_Name?: string,
    user_Name?: string,
    buying_Rate?: string,
    submittal_Rate?: string,
    salesmanager?: string,
    pO_Sub_Vendor_Company?: string,
    contact_Person_Name?: string,
    req_CategoryName?: string,
    recruiter_Company_Branch?: string,
    sales_Company_Branch?: string,
    incPer?: string,
    mRate?: number,
}

export const IncentiveReqList = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IIncentiveReqList>, loading: boolean });
    const modalHeader = () => {
        return (
            <React.Fragment>
                <p>Incentives On Reqs Lists</p>
            </React.Fragment>
        );
    };
    const pDate = (rowData: IAllRequirements) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const pTime = (rowData: IAllRequirements) => {
        let date;
        if (rowData?.pDate) date = format(new Date(rowData?.pDate), 'hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);

    };

    const submission_id = (rowData: IAllRequirements) => {
        const arOfCons = rowData.submission_id?.split(',');
        const arOfConsId: number[] = [];
        const arOfSubm = rowData.submission_status?.split(',');
        const subm: { [key: string]: number } = {};
        const key: string[] = [];
        arOfCons?.forEach(c => {
            arOfConsId.push(parseInt(c.split('-')[0]));
            key.push(c.split('-')[0].trim());
        });
        arOfSubm?.forEach(s => {
            const temp = s.split('-');
            subm[temp[0].trim()] = parseInt(temp[1]);
        });
        let is_Pending = 0;
        if (arOfCons) {
            for (let index = 0; index < arOfCons.length; index++) {
                if (subm[key[index]] === undefined) {
                    is_Pending++;
                };
            }
        }

        const countOfSubmissions = rowData.submission_id?.split(', ').length;
        const color = countOfSubmissions === rowData.noofSUBRej ? 'yellow' : (countOfSubmissions ? 'green' : rowData.recruiter ? 'yellow' : 'skyblue');

        return (
            <div style={{ background: color, minWidth: '70px', minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
                <span className={countOfSubmissions === rowData.noofSUBRej ? "text-black-alpha-50" : "text-white"}>{rowData.submission_id}</span></div>
        );
    };
    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const fromData = props.FromDate !== null ? `&MonthDate=${props.FromDate?.toDateString()}` : '';
        const toData = props.ToDate !== null ? `&ToDate=${props.ToDate?.toDateString()}` : '';
        const isReleasedQuery = props?.isReleasedTrue === true ? '&isReleased=1' : (props?.isHold === true ? "&isReleased=2" : "");
        const response = await Fetch("InvoiceTracking/getPOsByUserID", "GET", null, `user_ID=${props.singleData.user_ID}` + fromData + toData + isReleasedQuery, props.toast);
        if (response) {
            const data: IIncentiveReqList[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };
    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);
    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={modalHeader} className="p-fluid" onHide={props.hideDialog} draggable={false}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    // ref={dt} 
                    size="small" stripedRows showGridlines responsiveLayout="scroll"
                    // exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData}
                    emptyMessage="No Requirements found."
                    // header={header}
                    loading={tableData.loading}
                // rowClassName={rowClass}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req ID" />
                    <Column field="consultant_Name" header="Consultant Name" />
                    <Column field="fromDate" header="From Date" body={(rowData: any) => {
                        let date;
                        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} />
                    <Column field="toDate" header="To Date" body={(rowData: any) => {
                        let date;
                        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} />
                    <Column field="total_InvoiceHours" header="Hours" />
                    <Column field="buying_Rate" header="Buying Rate" />
                    <Column field="submittal_Rate" header="Submittal Rate" />
                    <Column field="mRate" header="Margin" body={(rowData: any) => <p>{Number(rowData.mRate || 0).toFixed(2)}</p>} />
                    <Column field="total_IncPer" header="IncPer %" />
                    <Column field="total_Amount" header="Amount" body={(rowData: any) => <p>$ {Number(rowData.total_Doller_Amount).toFixed(2)}</p>} />
                    <Column field="dollerRate" header="Dollar Rate" body={(rowData: any) => <p>₹ {rowData.dollerRate}</p>} />
                    <Column field="dollerRate" header="Converted Amount" body={(rowData: any) => <p>₹ {(rowData.total_Doller_Amount * rowData.dollerRate).toFixed(2)}</p>} />
                    <Column field="salesmanager" header="Salesmanager" />
                    <Column field="sales_Company_Branch" header="sales Company Branch" />
                    <Column field="user_Name" header="Recruiter" />
                    <Column field="recruiter_Company_Branch" header="Recruiter Company Branch" />
                    <Column field="project_Start_Date1" header="Project Start Date" />
                    <Column field="project_End_Date1" header="Project End Date" />
                    <Column field="pO_Status" header="PO Status" />
                    {/* <Column field="vendor_Company_Name" header="Vendor Company Name" /> */}
                    {/* <Column field="pO_Sub_Vendor_Company" header="PO Sub Vendor Company" /> */}
                    {/* <Column field="contact_Person_Name" header="Contact Person Name" /> */}
                    {/* <Column field="req_CategoryName" header="CategoryName" /> */}

                    {/*
                    <Column field="" header="Consultant Name" />
                    <Column field="" header="% Incentive" />
                    <Column field="dollerRate" header="Total Amount" />
                    */}


                    {/* <Column field="req_ID" header="Req.ID" sortable style={{ maxWidth: "16rem", overflow: "hidden" }} />
                    <Column field="incPer" header="Incentive Per %" />
                    <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                    <Column field="salesmanager" sortable header="Sales Manager" />
                    <Column field="sales_Company_Branch" header="Sales Comp(Branch)" />
                    <Column field="user_Name" sortable header="Recruiter" />
                    <Column field="recruiter_Company_Branch" header="Recruiter Comp(Branch)" />
                    <Column field="no_Auto_Allocation" header="Auto Allocation" body={(rowData) => <span style={{ color: rowData.no_Auto_Allocation ? 'red' : 'green' }}>{rowData.no_Auto_Allocation ? "No" : "yes"}</span>} /> */}



                    {/* <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} /> */}
                    {/* <Column field="req_Duration" header="Duration" /> */}
                    {/* <Column field="location" header="Location" /> */}
                    {/* <Column field="req_Sub_CategoryName" header="Sub Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable /> */}
                    {/* <Column field="req_Term" header="Job Term" /> */}
                    {/* <Column field="job_Type" header="Job Type" /> */}
                    {/* <Column field="pDate" header="Posted On" body={pDate} /> */}
                    {/* <Column field="pDate" header="Posted Time" body={pTime} /> */}
                    {/* <Column field="submission_id" header="Submittals" body={submission_id} /> */}
                    {/* <Column field="req_EndClient" sortable header="End Client" /> */}
                    {/* <Column field="client_Communication" sortable header="Client Communication" /> */}
                    {/* <Column field="client" sortable header="Client" /> */}
                    {/* <Column field="contact_Person_Name" header="Contact Person" /> */}
                    {/* {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="noofPO" sortable header="#PO" body={noofPO} />} */}
                </DataTable>
            </Dialog>
        </>
    );
}